module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-07-a701ab6f4969d6b0ff51d8dacc77667d.jpg";